import { render, staticRenderFns } from "./indexpage.vue?vue&type=template&id=14a1056e&scoped=true&"
var script = {}
import style0 from "./indexpage.vue?vue&type=style&index=0&id=14a1056e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a1056e",
  null
  
)

export default component.exports